import React, { useEffect, useState } from "react";
import './styles/App.css';
import twitterLogo from './assets/twitter-logo.svg';
import { ethers } from "ethers";
import contractAbi from './utils/contractABI.json';
import { networks } from './utils/networks';
import logo from "./assets/nfa.png"
import NFA1 from "./assets/NFA1.png"
import NFA2 from "./assets/NFA2.png"
import NFA3 from "./assets/NFA3.png"

const App = () => {
	const [currentAccount, setCurrentAccount] = useState('');
	const [network, setNetwork] = useState('');
	const [txn, setTxn] = useState(false)
	const [isMintStarted, setIsMintStarted] = useState(false)
	const [sacnLink, setScanLink] = useState("")
	const [totalMint, setTotalMint] = useState('');
	const [isMint, setIsMint] = useState(false);

	const TWITTER_HANDLE = 'dappcoder_';
	const CONTRACT_ADDRESS = "0x2cD47652b607977843D00D87E028f0476c09a6b1";
	// mainnet addrsss 0x2cD47652b607977843D00D87E028f0476c09a6b1
	const price = "0";

	const OPENSEA_LINK = 'https://opensea.io/collection/nfaddress';
	const TWITTER_LINK = 'https://twitter.com/nfaddress';
	const TWITTER_LINK1 = 'https://twitter.com/dappcoder_';
	const GITHUB_LINK = `https://github.com/Non-Fungible-Address`;


	const connectWallet = async () => {
		try {
			const { ethereum } = window;

			if (!ethereum) {
				alert("Get MetaMask -> https://metamask.io/");
				return;
			}

			const accounts = await ethereum.request({ method: "eth_requestAccounts" });

			console.log("Connected", accounts[0]);
			setCurrentAccount(accounts[0]);
		} catch (error) {
			console.log(error)
		}
	}

	const checkIfWalletIsConnected = async () => {
		const { ethereum } = window;

		if (!ethereum) {
			console.log('Make sure you have metamask!');
			return;
		} else {
			console.log('We have the ethereum object', ethereum);
		}

		const accounts = await ethereum.request({ method: 'eth_accounts' });

		if (accounts.length !== 0) {
			const account = accounts[0];
			console.log('Found an authorized account:', account);
			setCurrentAccount(account);
		} else {
			console.log('No authorized account found');
		}

		const chainId = await ethereum.request({ method: 'eth_chainId' });

		setNetwork(networks[chainId]);

		ethereum.on('chainChanged', handleChainChanged);
		function handleChainChanged(_chainId) {
			window.location.reload();
			console.log("Id has changed ********************", _chainId)
		}
	};

	const switchNetwork = async () => {
		if (window.ethereum) {
			try {
				await window.ethereum.request({
					method: 'wallet_switchEthereumChain',
					params: [{ chainId: '0x1' }],
				});
			} catch (error) {

				if (error.code === 4902) {
					try {
						await window.ethereum.request({
							method: 'wallet_addEthereumChain',
							params: [
								{
									chainId: '0x1',
									chainName: 'Mainnet',
									rpcUrls: ['https://rpc-mumbai.maticvigil.com/'],
									nativeCurrency: {
										name: "ETH",
										symbol: "ETH",
										decimals: 18
									},
									blockExplorerUrls: ["https://etherscan.io/"]
								},
							],
						});
					} catch (error) {
						console.log(error);
					}
				}
				console.log(error);
			}
		} else {
			alert('MetaMask is not installed. Please install it to use this app: https://metamask.io/download.html');
		}
	}

	const mintDomain = async () => {
		try {
			const { ethereum } = window;
			if (ethereum) {
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				const contract = new ethers.Contract(CONTRACT_ADDRESS, contractAbi.abi, signer);

				console.log("Going to pop wallet now to pay gas...")
				setIsMintStarted(true)
				let tx = await contract._safeClaim(currentAccount, { value: ethers.utils.parseEther(price) });
				const receipt = await tx.wait();
				if (receipt.status === 1) {
					console.log("Congrulation you have NFT minted! https://etherscan.io/tx/" + tx.hash);
					setScanLink(`https://etherscan.io//tx/` + tx.hash)
					setTxn(true)
				}
				else {
					alert("Transaction failed! Please try again");
				}
			}
		}
		catch (error) {
			alert(error.message)
			setIsMintStarted(false)
			console.log(error);
		}
	}

	const getTotalMint = async () => {
		try {
			const { ethereum } = window;
			if (ethereum) {
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				// const contractABI = ["function totalMint() public view returns (uint256)"];
				const contractObject = new ethers.Contract(CONTRACT_ADDRESS, contractAbi.abi, signer);
				const result = await contractObject.totalMint();
				const altresutl = result - 1;
				const newresult = altresutl.toString();
				console.log("get the total mint: ", newresult);
				setTotalMint(newresult)
			}
		} catch (err) {
			throw err;
		}
	};

	const alreadyMinted = async () => {
		try {
			const { ethereum } = window;
			if (ethereum) {
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				const contractObject = new ethers.Contract(CONTRACT_ADDRESS, contractAbi.abi, signer);
				const result = await contractObject.minted(currentAccount);
				console.log(result);
				setIsMint(result);
			}
		} catch (err) {
			throw err;
		}
	};


	const renderInputForm = () => {
		if (network !== 'Mainnet') {
			return (
				<div className="connect-wallet-container">
					<h2>Please switch to Mainnet</h2>
					<button className='cta-button mint-button' onClick={switchNetwork}>
						Click here to switch
					</button>
				</div>
			);
		}
		return (
			<div>
				{txn ?
					<div className="form-container">
						<div className="first-row">
							<div className="button-container">
								<div className="minted-card">
									<p>Congratulations NFT minted ✅</p>
									<a href={sacnLink}>View Tx on Etherscan</a>
									<a href={`https://opensea.io/assets/ethereum/${CONTRACT_ADDRESS}/${totalMint}`}>View NFT on Opensea</a>
									<a href={"https://bit.ly/3VslQN4"}>Tweet about us</a>
									<p className="note2">Note: If you can't see your NFT here, please check-it in your opensea account.</p>
								</div>
							</div>
						</div>
					</div> :
					<div className="form-container">
						<div className="first-row">
							<div className="button-container">
								<p className="price">Initial 1000 NFTs are Free Mint</p>
								<p className="price">Mint Fee - $0</p>
								{/* <p className="total-mint">Total Mint: {totalMint}</p> */}
								<button className='cta-button mint-button' disabled={isMint} onClick={() => {
									mintDomain();
								}}>
									{isMintStarted && "Minting..."}
									{!isMintStarted && "Mint"}
								</button>
								<p className="note">Note: One address can claim one NFT</p>
							</div>
						</div>
					</div>
				}
			</div >
		)
	}

	useEffect(() => {
		checkIfWalletIsConnected();
		getTotalMint();
		alreadyMinted();
	});

	return (
		<div className="App">
			<div className="container">
				<div className="header-container">
					<header>
						<div className="left">
							<img alt="NFA-logo" src={logo} width={"100px"} height={"100px"} />
						</div>
						<div className="right">
							{!currentAccount ? (<button onClick={connectWallet}>Connect Wallet</button>) : (
								<p>[ {currentAccount.slice(0, 6)}...{currentAccount.slice(-4)} ]</p>)}
						</div>
					</header>
					<main>
						<ul>
							<li><a href={OPENSEA_LINK}>OpenSea</a></li>
							<li><a href={TWITTER_LINK}>Twitter</a></li>
							<li><a href={GITHUB_LINK}>Github</a></li>
						</ul>
						<p>Non Fungible Address is an on-chain generative art experiment that gives identity to your address as an NFT, each NFT resonates with Ethereum logo. Rarest NFT that you can own.</p>
						<p className='main--p'>Unique address = Unique NFT = Rarest NFT that you can own ⭐️</p>
						<p className='main---p'>Feel free to mint you address as NFT 💎</p>
					</main>
				</div>
				{!currentAccount ?
					<div className='cards'>
						<p>Example NFA</p>
						<div className='cards--logo'>
							<img alt="NFA1" src={NFA1} width={"300"} height={"300"} />
							<img alt="NFA1" src={NFA2} width={"300"} height={"300"} />
							<img alt="NFA1" src={NFA3} width={"300"} height={"300"} />
						</div>
					</div> : renderInputForm()}

				<div className="footer-container">
					<img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
					<a
						className="footer-text"
						href={TWITTER_LINK1}
						target="_blank"
						rel="noreferrer"
					>{`by @${TWITTER_HANDLE}`}</a>
				</div>
			</div>
		</div>
	);
};

export default App;